import Anchor from './Anchor';
import Text from './Text';
import ICON_RADIO_OFF_LIGHT from '../../../public/static/v4/common/icon-radio-off-light.svg';
import ICON_RADIO_OFF from '../../../public/static/v4/common/icon-radio-off.svg';
import ICON_RADIO_ON_LIGHT from '../../../public/static/v4/common/icon-radio-on-light.svg';
import ICON_RADIO_ON from '../../../public/static/v4/common/icon-radio-on.svg';
import useTheme from '../hook/useTheme';
import {ITheme} from '../type';

interface IProps {
  gap: number;
  text: string;
  textClassName: string;
  className?: string;
  isSelected: boolean;
  onClick?: () => void;
}

export default function RadioText({
  gap,
  text,
  textClassName,
  className,
  isSelected,
  onClick,
}: IProps) {
  const {theme} = useTheme();

  return (
    <Anchor
      display="flex"
      onClick={onClick}
      className={cn('items-center', className)}
    >
      <img src={getRadioIconMap[theme](isSelected)} alt="" />
      <Text
        className={textClassName}
        style={{
          marginLeft: gap,
        }}
      >
        {text}
      </Text>
    </Anchor>
  );
}

const getRadioIconMap: Record<ITheme, (isSelected: boolean) => string> = {
  dark: isSelected => (isSelected ? ICON_RADIO_ON : ICON_RADIO_OFF),
  light: isSelected =>
    isSelected ? ICON_RADIO_ON_LIGHT : ICON_RADIO_OFF_LIGHT,
};
